import moment from "moment";
import { actionTypes, Types } from "../../context/action/action";
import store from "../../context/store/store";
import { clearArchiveMessage } from "../socketChatService/newChat";
import { toastInformation } from "../callService/common";
import { v4 as uuidv4 } from "uuid";
import { ChatService } from "../chatService";
import { gifFormat, imageFormat, mp3Formats, strickerFormat, videoFormat } from "../utils";
export class DraftService {
  public static async openChatNewNessage(history:any) {
    // history.push('/chats');
    clearArchiveMessage();
        store.dispatch({
      type: Types.OPEN_CHAT_WINDOW,
      payload: {
        isChatWindow:false,
        chatWindowDetails:{},
        isMySpace:false,
        openNewMessage: false
      }
    });
    store.dispatch({
      type: Types.OPEN_NEW_MESSAGE,
      payload: {
        isNewMessageWindow: true,
        newUserMessage: [],
        newUserDetails: []
      }
    });
  }
  public static async removedFailedContact(indexValue:any,type:any) {
    let recentChat:any = store.getState().recentchatReducer;
    if(indexValue){
      const slicedArray = recentChat.failedContact.slice();
      const sliceData = slicedArray.filter((value:any)=>value.id!==indexValue?.id);
      store.dispatch({
        type: Types.FAILED_CONTACT,
        payload: {
          failedContact:[...sliceData]
        }
      });
      if(type === "delete"){
        toastInformation("Failed Message(s) Deleted", "success");
      } else {
        //toastInformation("Send Message", "success");
      }
      
    }
  }

  public static async sendMessageBefore(messageDetails:any){
    let { messageList }: any = store.getState().chatSocketReducerState;
    messageList.push(messageDetails);
    store.dispatch({
      type: actionTypes.MESSAGE_LIST,
      payload: {
          messageList: messageList,
          fileUploadingStatus: false
      }
  });
  }
  public static async addFailedMessage(chatwindowDetails:any, message:any){
    let recentChat:any = store.getState().recentchatReducer; 
    let { messageList }: any = store.getState().chatSocketReducerState;
    let contactObject: any = store.getState().contactReducer;
    const failedContact = recentChat.failedContact;
    //const chatWindow = chatwindowDetails?.sip_login_id;
    if(Array.isArray(failedContact)){
      failedContact.push(message);
    }
    const findIndex = messageList.findIndex((value:any)=>value?.id===message.id);
    if(findIndex>-1){
      messageList[findIndex] = message;
      messageList[findIndex].fromcaller_details = contactObject.workContactsnew[message.from];
    } else {
      message.fromcaller_details =  contactObject.workContactsnew[message.from];
      messageList.push(message);
    }
    store.dispatch({
      type: actionTypes.MESSAGE_LIST,
      payload: {
          messageList: messageList,
          fileUploadingStatus: false
      }
  });
    store.dispatch({
      type: Types.SAVE_FAILED_MESSAGE,
      payload: {
        failedContact:failedContact
      }
    });
  }
  public static async deleteDraftMessage(msgid:any) {
    let recentChat:any = store.getState().recentchatReducer;
    const indexValue = await recentChat?.draftContact.findIndex((value:any)=>{
      return value.id ===msgid;
    });
    if(indexValue>-1){
      const slicedArray = recentChat.draftContact.slice();
      slicedArray.splice(indexValue,1);
      
      store.dispatch({
        type: Types.SAVE_DRAFT_MESSAGE,
        payload: {
          draftContact:[...slicedArray]
        }
      });
    }
    store.dispatch({
      type: Types.OPEN_CHAT_WINDOW,
      payload: {
        isChatWindow: false,
        chatWindowDetails: {},
        isMySpace: false,
        isNewMessageWindow: false,
        newUserMembers: []
      }
    });
  }
  public static async removeDraftMessage(chatwindowDetails:any,value?:string,editDraft?:string) {
    let recentChat:any = store.getState().recentchatReducer;
    if((chatwindowDetails?.sip_login_id || chatwindowDetails?.team_id)&& !editDraft && value !== 'newWindow'){
    const indexValue = await recentChat?.draftContact.findIndex((value:any)=>{
      return value?.contactDetail &&  (value?.contactDetail?.sip_login_id || value?.contactDetail?.team_id) &&
        ((value?.contactDetail?.sip_login_id===chatwindowDetails?.sip_login_id) || (
          value?.contactDetail?.team_id_prefix+value?.contactDetail?.team_id===
          chatwindowDetails?.team_id_prefix + chatwindowDetails?.team_id));
    });
    if(indexValue>-1){
      const slicedArray = recentChat.draftContact.slice();
      slicedArray.splice(indexValue,1);
      store.dispatch({
        type: Types.SAVE_DRAFT_MESSAGE,
        payload: {
          draftContact:[...slicedArray]
        }
      });
      ChatService.editDraft('delete');
    }
  } else if(editDraft) {
    const indexValue = await recentChat?.draftContact.findIndex((value:any)=>{
      return value?.contactDetail?.sip_login_id === editDraft
   
      //return value.id ===editDraft;
    });
    
    if(indexValue>-1){
      const slicedArray = recentChat.draftContact.slice();
      slicedArray.splice(indexValue,1);
     
      store.dispatch({
        type: Types.SAVE_DRAFT_MESSAGE,
        payload: {
          draftContact:[...slicedArray]
        }
      });
      ChatService.editDraft('delete');
    }
  }  else {
    const indexValue = await recentChat?.draftContact.findIndex((value:any)=>{
      return value?.contactDetail === 'newWindow';
    });
    const slicedArray = recentChat.draftContact.slice();
    if(indexValue>-1){
    slicedArray.splice(indexValue,1);
    store.dispatch({
      type: Types.SAVE_DRAFT_MESSAGE,
      payload: {
        draftContact:[...slicedArray]
      }
    });
    ChatService.editDraft('delete');
   }
    
   
  }
  }
  public static async updateDraftMessage(chatwindowDetails:any,value:string,files?:any) {
  
    if(value?.trim() || files?.length >0){
    const unixTimeStamp = moment().valueOf();
    let recentChat:any = store.getState().recentchatReducer;
    const uuid = uuidv4();
    const draftMesg:any = {
      contactDetail:chatwindowDetails,
      timeStamp: unixTimeStamp,
      id:uuid
    };
    if(chatwindowDetails?.team_id || chatwindowDetails?.sip_login_id ){
    const indexValue = await recentChat?.draftContact.findIndex((value:any)=>{
      return value?.contactDetail && (value?.contactDetail?.sip_login_id || value?.contactDetail?.team_id) &&
        ((value?.contactDetail?.sip_login_id===chatwindowDetails?.sip_login_id) || (
          value?.contactDetail?.team_id_prefix+value?.contactDetail?.team_id===
          chatwindowDetails?.team_id_prefix + chatwindowDetails?.team_id));
    });
  
    let initalArray = [];
    initalArray.push(draftMesg);
    if(indexValue===-1){
      if(value){
        draftMesg.msgText = value;
      }
      if(files){
        draftMesg.files = files;
        let fileType = videoFormat.indexOf(files[0]?.fileType) !== -1?"Video" : mp3Formats.indexOf(files[0]?.fileType) !== -1?"Audio":
        gifFormat.indexOf(files[0]?.fileType) !== -1?"GIF" :
        strickerFormat.indexOf(files[0]?.fileType) !== -1?"Stricker" :
        imageFormat.indexOf(files[0]?.fileType) !== -1?"Image" : "Document"
        draftMesg.msgText = fileType;
      }
      store.dispatch({
        type: Types.SAVE_DRAFT_MESSAGE,
        payload: {
          draftContact:[...recentChat?.draftContact,...initalArray]
        }
      });
    } else {
    let indexIndex = indexValue;
      const slicedArray = recentChat.draftContact.slice();
      if(files){
        slicedArray[indexIndex].files = files;
      }
      if(value){
        slicedArray[indexIndex].msgText = value;
      }
      store.dispatch({
        type: Types.SAVE_DRAFT_MESSAGE,
        payload: {
          draftContact:[...slicedArray]
        }
      });
    }
  } else if(chatwindowDetails === "newWindow"){
    const indexValue1 = await recentChat?.draftContact.findIndex((value:any)=>{
      return value?.contactDetail && value?.contactDetail === "newWindow"
    });
 
    let initalArray = [];
    initalArray.push(draftMesg);
    if(indexValue1===-1){
      if(value){
        draftMesg.msgText = value;
      }
      if(files){
        draftMesg.files = files;
      }
      store.dispatch({
        type: Types.SAVE_DRAFT_MESSAGE,
        payload: {
          draftContact:[...recentChat?.draftContact,...initalArray]
        }
      });
     
    } else {
    let indexIndex = indexValue1;
      const slicedArray = recentChat.draftContact.slice();
      if(files){
        slicedArray[indexIndex].files = files;
      }
      if(value){
        slicedArray[indexIndex].msgText = value;
      }
      store.dispatch({
        type: Types.SAVE_DRAFT_MESSAGE,
        payload: {
          draftContact:[...slicedArray]
        }
      });
    }
  }  else {
    
    if(value){
      draftMesg.msgText = value;
    }
    if(files){
      draftMesg.files = files;
    }
    let initalArray = [];
    initalArray.push(draftMesg);
    store.dispatch({
      type: Types.SAVE_DRAFT_MESSAGE,
      payload: {
        draftContact:[...recentChat?.draftContact,...initalArray]
      }
    });
  }
}
}
}